export const AST_SIGNMAIL_HANDOFF_DURATION_MS = 5000;
export const AST_SIGNMAIL_TRANSFER_TIMEOUT_MS = 10_000;
export const AST_SIGNMAIL_TEXT_MAX_LENGTH = 500;

/** Core `ASTSignMailMode` value that allows auto AST SignMail routing. */
export const AST_SIGNMAIL_MODE_ENABLED = 1;
